import React, { useEffect, useState } from "react";

import { PackagePricingType } from "../../../models";
import { CheckOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import SinglePackageCard from "../StepTwo/SinglePackageCard";

const StepOne = ({
  packagePricing,
  eventInfo,
  setBundle,
  setCurrent,
}: {
  packagePricing: PackagePricingType[];
  eventInfo: any;
  setBundle: React.Dispatch<React.SetStateAction<PackagePricingType | null>>;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
}) => {
  return (
    <div className=" text-center my-4 sm:my-6">
      <div className="text-white  text-[14px] sm:text-[19px] 2xl:text-[24px] mb-8">
        Odaberite željeni paket!
      </div>
      <div className="w-[90%] xl:w-[85%] m-auto sm:grid grid-cols-4 gap-4 xl:gap-8">
        <SinglePackageCard
          packageInfo={packagePricing?.find((el) => el?.package === "A")}
          packageType="A"
          eventInfo={eventInfo?.[0]}
          setBundle={setBundle}
          setCurrent={setCurrent}
          firstDayDate={eventInfo?.[0]?.firstDayDate}
          secondDayDate={eventInfo?.[0]?.secondDayDate}
        />
        <SinglePackageCard
          packageInfo={packagePricing?.find((el) => el?.package === "B")}
          packageType="B"
          eventInfo={eventInfo?.[0]}
          setBundle={setBundle}
          setCurrent={setCurrent}
          firstDayDate={eventInfo?.[0]?.firstDayDate}
          secondDayDate={eventInfo?.[0]?.secondDayDate}
        />
        <SinglePackageCard
          packageInfo={packagePricing?.find((el) => el?.package === "C")}
          packageType="C"
          eventInfo={eventInfo?.[0]}
          setBundle={setBundle}
          setCurrent={setCurrent}
          firstDayDate={eventInfo?.[0]?.firstDayDate}
          secondDayDate={eventInfo?.[0]?.secondDayDate}
        />
        <SinglePackageCard
          packageInfo={packagePricing?.find((el) => el?.package === "D")}
          packageType="D"
          eventInfo={eventInfo?.[0]}
          setBundle={setBundle}
          setCurrent={setCurrent}
          firstDayDate={eventInfo?.[0]?.firstDayDate}
          secondDayDate={eventInfo?.[0]?.secondDayDate}
        />
      </div>
      <div className="text-white flex justify-center font-saira text-[12px] 2xl:text-[14px] mt-9">
        <div className="text-custom-pink-900">*</div> Navedene cijene iskazane
        bez PDV-a
      </div>
    </div>
  );
};

export default StepOne;
